<template>
  <div class="bg-white m-0">
      <CContainer>
          <CRow>
              <CCol sm="12">
                  <div class="custom-40px-600 text-center mt-5">Interviewrr</div>
                  <div class="text-center">
                      <label class="m-3 font-color-171717">About Us</label
            >
  
            <label class="m-3 font-color-171717"
              >Products</label
            >
  
            <label class="m-3 font-color-171717"
              >Services</label
            >
  
            <label class="m-3 font-color-171717"
              >Contact</label
            >
  
            <label class="m-3 font-color-171717"
              >FAQ</label
            >
          </div>
            <br />
         
           
          </CCol>
  
       
        
        </CRow>
      </CContainer>
      <hr />
      <CRow>
        <CCol sm="6"><label class="m-3 font-color-171717">© 2023 interviewrr.ai. All rights reserved.</label></CCol>
              <CCol sm="6">
                  <div class="text-right"><label class="m-3 font-color-171717">Privacy Policy</label
            >
  
            <label class="m-3 font-color-171717"  @click="GoToLegal()"
              >Terms and Conditions</label
            >
  
            <label class="m-3 font-color-171717"
              >Cookie Policy</label
            >
          </div> </CCol>
      </CRow>
      <div class="chat-container" v-show="isChatVisible">
    <div class="chat-header">
      <h3 class="custom-16px-500 text-left p-2">Messages</h3>
    </div>
    <div class="messages p-2">
      <div
        v-for="(msg, index) in messages"
        :key="index"
        :class="['message', msg.isUser ? 'user-message' : 'bot-message']"
        @click="selectMessage(msg)"
      >
        <strong v-if="!msg.isUser">{{ msg.senderName }}:</strong> {{ msg.text }}
      </div>
    </div>

    <!-- Message Input Section -->
    <form @submit.prevent="sendMessage" class="message-form">
      <input 
        type="text" 
        v-model="userMessage" 
        placeholder="Send your message" 
        required
      />
      <img src="../assets/img/send.png" width="30px" height="30px" class="send-icon" @click="sendMessage"/>
    </form>
  </div>

  <!-- Icon to open the chat -->
  <div class="chat-icon" @click="toggleChatVisibility">
    <img src="../assets/img/toggle-chat.png" alt="Chat Icon" />
  </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
  name: "TheFooter",
  data() {
      return {
        botToken: "7816967731:AAHh11dwPtvOe_2Dt26fi0djUYCFL5xd6oY", // Your bot token
    chatId: 89341897, // Chat ID to be set dynamically
    userMessage: "", // User input message
    messages: [], // Store all messages
    lastUpdateId: null, // Keep track of last update ID for getUpdates
    isChatVisible: false, // Whether the chat is visible or not
    fetchingMessages: false, // Flag to prevent multiple fetches at the same time
    userName: "", // Store user name
    isNameAsked: false, // Flag to check if the bot has already asked for the name
    lastUserMessageId: null, // Track the last message ID of the user to reply to
    selectedMessageId: null, // Store the ID of the selected message to reply to
    selectedChatId: null, // Store the chat_id of the selected user,
    userFirstName: "", // User's first name
    userLastName: "", // User's last name
    userKey: "", // User key based on first and last name

      };
  },
  mounted() {
      axios
          .post(`https://api.telegram.org/bot${this.botToken}/deleteWebhook`)
          .then(() => {
              console.log("Webhook deleted, starting to poll for messages.");
          })
          .catch((error) => {
              console.error("Error deleting webhook:", error);
          });
  },
  methods: {
      GoToAbout() {
          this.$router.push("About");
      },
      GoToContact() {
          this.$router.push("ContactUs");
      },
      GoToLegal() {
          this.$router.push("Legal");
      },
      GoToBlog() {
          this.$router.push("Blog");
      },
      GoToLinkedIn() {
          window.open("https://www.linkedin.com/company/70999536/");
      },
      GoToFacebook() {
          window.open("https://www.facebook.com/pickiddo");
      },
      GoToInstagram() {
          window.open("https://www.instagram.com/pickiddo");
      },
      GoToTiktok() {
          window.open("https://www.tiktok.com/@pickiddo");
      },
      GoToYoutube() {
          window.open("https://www.youtube.com/@pickiddo");
      },
      GoToWhatsapp() {
          window.open("https://wa.me/600106597700");
      },

      changeImageSrc() {
          // Change image source to hover image source
          this.imageSrc = this.hoverImageSrc;
      },
      resetImageSrc() {
          // Reset image source to original image source
      },
      changeImageSrcInsta() {
          // Change image source to hover image source
          this.imageSrcInsta = this.hoverImageSrcInsta;
      },
      resetImageSrcInsta() {
          // Reset image source to original image source
      },
      changeImageSrcFb() {
          // Change image source to hover image source
          this.imageSrcFb = this.hoverImageSrcFb;
      },
      resetImageSrcFb() {
          // Reset image source to original image source
      },
      changeImageSrcLn() {
          // Change image source to hover image source
          this.imageSrcLn = this.hoverImageSrcLn;
      },
      resetImageSrcLn() {
          // Reset image source to original image source
      },
      changeImageSrcWs() {
          // Change image source to hover image source
          this.imageSrcWs = this.hoverImageSrcWs;
      },
      resetImageSrcWs() {
          // Reset image source to original image source
      },
      changeImageSrcYou() {
          // Change image source to hover image source
          this.imageSrcYou = this.hoverImageSrcYou;
      },
      resetImageSrcYou() {
          // Reset image source to original image source
      },
      async sendMessage() {
const message = this.userMessage.trim();
if (!message) {
  alert("Please enter a message.");
  return; // Prevent sending an empty message
}

// Step 1: Ask for Name
if (!this.userName && !this.isNameAsked) {
  this.messages.push({ text: "Please enter your name so we can continue chatting!", isUser: false, senderName: "Bot" });
  this.isNameAsked = true; // Flag that the name is being asked
  this.userMessage = ""; // Clear input field
  this.$nextTick(() => this.scrollToBottom()); // Ensure scroll happens after DOM update
  return;
}

// Step 2: Store Name and move to Phone Number request
if (this.isNameAsked && !this.userName) {
  this.userName = message; // Store the user's name
  this.messages.push({ text: `Thank you, ${this.userName}! Now, please enter your phone number and email address, separated by a space.`, isUser: false, senderName: "Bot" });
  this.isNameAsked = false; // Stop asking for the name
  this.isContactAsked = true; // Now ask for phone number and email
  this.userMessage = ""; // Clear input field
  this.$nextTick(() => this.scrollToBottom()); // Ensure scroll happens after DOM update
  return;
}

// Step 3: Store Phone and Email (Both combined)
if (this.isContactAsked && !this.userContact) {
  const [phone, email] = message.split(' '); // Assuming the user enters phone and email separated by a space
  if (phone && email) {
    this.userContact = { phone, email }; // Store phone and email together in one object
    this.messages.push({
      text: `Thank you! Here’s the info you provided: \nName: ${this.userName} \nPhone: ${this.userContact.phone} \nEmail: ${this.userContact.email}`,
      isUser: false,
      senderName: "Bot"
    });
    this.messages.push({
      text: `Hi ${this.userName}, We received it and will get back to you shortly. In the meantime, how may I assist you further today?`,
      isUser: false,
      senderName: "Bot"
    });

    this.isContactAsked = false; // Stop asking for phone and email
    this.isDetailsComplete = true; // Details are complete

    const userDetailsMessage = `New User Details:\nName: ${this.userName}\nPhone: ${this.userContact.phone}\nEmail: ${this.userContact.email}`;
    await this.sendToTelegram(userDetailsMessage);
    this.userMessage = ""; // Clear input field
    this.$nextTick(() => this.scrollToBottom()); // Ensure scroll happens after DOM update
    return;
  } else {
    this.messages.push({
      text: "Please enter both your phone number and email, separated by a space.",
      isUser: false,
      senderName: "Bot"
    });
    this.userMessage = ""; // Clear input field
    this.$nextTick(() => this.scrollToBottom()); // Ensure scroll happens after DOM update
    return;
  }
}

// If user has entered their name and details are complete
const messageTextWithName = `${this.userName}: ${message}`;
try {
  const url = `https://api.telegram.org/bot${this.botToken}/sendMessage`;
  const payload = {
chat_id: this.selectedChatId || this.chatId, // Send to selected user or fallback to group chat
text: messageTextWithName,
reply_to_message_id: this.selectedMessageId || this.lastUserMessageId || null, // Reply to specific user's message
};
  const response = await axios.post(url, payload);
  if (response.data.ok) {
    this.messages.push({ text: message, isUser: true, senderName: this.userName });
    this.userMessage = ""; // Clear input field
    this.selectedMessageId = null; // Reset after reply
  } else {
    console.error("Error sending message:", response.data.description);
  }
} catch (error) {
  console.error("Error sending message:", error);
}
this.$nextTick(() => this.scrollToBottom());
},
async sendToTelegram(message) {
  try {
    const url = `https://api.telegram.org/bot${this.botToken}/sendMessage`;
    const payload = {
      chat_id: this.selectedChatId || this.chatId, // If a specific chat_id is selected, use it; otherwise, use the default group chat_id
      text: message, // The message you want to send
    };

    const response = await axios.post(url, payload);
    if (response.data.ok) {
      console.log("Message sent successfully!");
    } else {
      console.error("Error sending message:", response.data.description);
    }
  } catch (error) {
    console.error("Error sending message:", error);
  }
},
  async fetchMessages() {
    if (this.fetchingMessages) return;
    this.fetchingMessages = true;

    try {
      const url = `https://api.telegram.org/bot${this.botToken}/getUpdates`;
      const payload = this.lastUpdateId ? { offset: this.lastUpdateId + 1 } : {};
      const response = await axios.post(url, payload);
      const updates = response.data.result;

      if (updates.length > 0) {
        updates.forEach((update) => {
          if (update.message) {
            const chatId = update.message.chat.id;
            const text = update.message.text || "[No Text]";
            const firstName = update.message.from.first_name || "Unknown";
            const lastName = update.message.from.last_name || ""; // Optional
            const sender = `${firstName} ${lastName}`.trim() || "User";

            // Log user information
            console.log(`Received message from ${sender}`);
            console.log(`Message: ${text}`);
            console.log(`Chat ID: ${chatId}`);

            // Save the last user message ID (this allows us to reply to the most recent user message)
            if (update.message.chat.id === chatId) {
              this.lastUserMessageId = update.message.message_id;
            }

            // Add received message to the list
            this.messages.push({
              text: text,
              isUser: false, // Bot message
              senderName: sender,
              chatId, // Store sender's chatId
              message_id: update.message.message_id, // Save the message ID for replies
            });
          }

          // Update last update ID
          this.lastUpdateId = update.update_id;
        });

        // Scroll to the bottom of the chat container
        this.scrollToBottom();
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      this.fetchingMessages = false;
    }
  },

  toggleChatVisibility() {
  this.isChatVisible = !this.isChatVisible;
  if (this.isChatVisible) {
    this.fetchMessages();
    this.fetchInterval = setInterval(this.fetchMessages, 2000); // Poll every 2 seconds
  } else {
    clearInterval(this.fetchInterval); // Stop polling when chat is closed
  }
},

  selectMessage(msg) {
    this.selectedMessageId = msg.message_id; // Store the message ID to reply to
    this.selectedChatId = msg.chatId; // Store the chat_id of the user who sent the message
  },
  scrollToBottom() {
  this.$nextTick(() => {
    const chatContainer = document.querySelector(".messages");
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  });
},

  },
};
</script>

<style>
.pointer:hover {
  cursor: pointer;
  text-decoration: underline;
}

.hover-pointer1 {
  cursor: pointer;
  /* Set cursor to pointer on hover */
}

.hover-pointer2 {
  cursor: pointer;
  /* Set cursor to pointer on hover */
}

.hover-pointer3 {
  cursor: pointer;
  /* Set cursor to pointer on hover */
}

.hover-pointer4 {
  cursor: pointer;
  /* Set cursor to pointer on hover */
}

.hover-pointer5 {
  cursor: pointer;
  /* Set cursor to pointer on hover */
}

.hover-pointer6 {
  cursor: pointer;
  /* Set cursor to pointer on hover */
}

.chat-container {
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 120px;
  right: 20px;
  width: 300px;
  height: 400px;
  border-radius: 20px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  z-index: 1000;
}

.chat-header {
  color: #171717;
  text-align: left;
  font-size: 12px;
  background: #fff;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  padding: 5px;
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: white;
}

.messages {
  flex-grow: 1;
  overflow-y: auto;
  margin-bottom: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 280px;
  /* Adjust based on your design */
  scroll-behavior: smooth;
  /* Enables smooth scrolling */
}

.message {
  max-width: 60%;
  padding: 10px;
  border-radius: 10px;
  word-wrap: break-word;
  display: inline-block;
}

.user-message {
  align-self: flex-start;
  border-radius: 20px;
  background: var(--surface-surface-tertiary, #F5F5F5);
  padding: 10px;
  color: #171717;
}

.bot-message {
  align-self: flex-end;
  border-radius: 20px;
  background: #928AFD;
  padding: 10px;
  color: #fff;
}

.message-form {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: #fff;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}

input {
  flex-grow: 1;
  padding: 10px;
  font-size: 16px;
  border: 1px solid var(--Grayscale-200, #E5E5E5);
  border-radius: 25px;
  height: 40px;
}

.send-icon {
  cursor: pointer;
}

.chat-icon {
  position: fixed;
  bottom: 20px;
  right: 20px;
  cursor: pointer;
}

.chat-icon img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
</style>


<!-- <script>
import axios from "axios";
export default {
    name: "TheFooter",
    data() {
        return {
          botToken: "7843663557:AAHHntn1bPWuazRlNwiiJEgVjGz2wkeMhO4", // Bot Token
      chatId: "-1002499340521", // Group Chat ID (used for broadcasting)
      userMessage: "", // User input message
      messages: [], // Store all messages
      lastUpdateId: null, // Keep track of last update ID for getUpdates
      isChatVisible: false, // Whether the chat is visible or not
      fetchingMessages: false, // Flag to prevent multiple fetches at the same time
      userName: "", // Store user name
      isNameAsked: false, // Flag to check if the bot has already asked for the name
      lastUserMessageId: null, // Track the last message ID of the user to reply to
      selectedMessageId: null, // Store the ID of the selected message to reply to
      selectedChatId: null, // Store the chat_id of the selected user

        };
    },
    mounted() {
        axios
            .post(`https://api.telegram.org/bot${this.botToken}/deleteWebhook`)
            .then(() => {
                console.log("Webhook deleted, starting to poll for messages.");
            })
            .catch((error) => {
                console.error("Error deleting webhook:", error);
            });
    },
    methods: {
        GoToAbout() {
            this.$router.push("About");
        },
        GoToContact() {
            this.$router.push("ContactUs");
        },
        GoToLegal() {
            this.$router.push("Legal");
        },
        GoToBlog() {
            this.$router.push("Blog");
        },
        GoToLinkedIn() {
            window.open("https://www.linkedin.com/company/70999536/");
        },
        GoToFacebook() {
            window.open("https://www.facebook.com/pickiddo");
        },
        GoToInstagram() {
            window.open("https://www.instagram.com/pickiddo");
        },
        GoToTiktok() {
            window.open("https://www.tiktok.com/@pickiddo");
        },
        GoToYoutube() {
            window.open("https://www.youtube.com/@pickiddo");
        },
        GoToWhatsapp() {
            window.open("https://wa.me/600106597700");
        },

        changeImageSrc() {
            // Change image source to hover image source
            this.imageSrc = this.hoverImageSrc;
        },
        resetImageSrc() {
            // Reset image source to original image source
        },
        changeImageSrcInsta() {
            // Change image source to hover image source
            this.imageSrcInsta = this.hoverImageSrcInsta;
        },
        resetImageSrcInsta() {
            // Reset image source to original image source
        },
        changeImageSrcFb() {
            // Change image source to hover image source
            this.imageSrcFb = this.hoverImageSrcFb;
        },
        resetImageSrcFb() {
            // Reset image source to original image source
        },
        changeImageSrcLn() {
            // Change image source to hover image source
            this.imageSrcLn = this.hoverImageSrcLn;
        },
        resetImageSrcLn() {
            // Reset image source to original image source
        },
        changeImageSrcWs() {
            // Change image source to hover image source
            this.imageSrcWs = this.hoverImageSrcWs;
        },
        resetImageSrcWs() {
            // Reset image source to original image source
        },
        changeImageSrcYou() {
            // Change image source to hover image source
            this.imageSrcYou = this.hoverImageSrcYou;
        },
        resetImageSrcYou() {
            // Reset image source to original image source
        },
        async sendMessage() {
  const message = this.userMessage.trim();
  if (!message) {
    alert("Please enter a message.");
    return; // Prevent sending an empty message
  }

  // Step 1: Ask for Name
  if (!this.userName && !this.isNameAsked) {
    this.messages.push({ text: "Please enter your name so we can continue chatting!", isUser: false, senderName: "Bot" });
    this.isNameAsked = true; // Flag that the name is being asked
    this.userMessage = ""; // Clear input field
    this.$nextTick(() => this.scrollToBottom()); // Ensure scroll happens after DOM update
    return;
  }

  // Step 2: Store Name and move to Phone Number request
  if (this.isNameAsked && !this.userName) {
    this.userName = message; // Store the user's name
    this.messages.push({ text: `Thank you, ${this.userName}! Now, please enter your phone number and email address, separated by a space.`, isUser: false, senderName: "Bot" });
    this.isNameAsked = false; // Stop asking for the name
    this.isContactAsked = true; // Now ask for phone number and email
    this.userMessage = ""; // Clear input field
    this.$nextTick(() => this.scrollToBottom()); // Ensure scroll happens after DOM update
    return;
  }

  // Step 3: Store Phone and Email (Both combined)
  if (this.isContactAsked && !this.userContact) {
    const [phone, email] = message.split(' '); // Assuming the user enters phone and email separated by a space
    if (phone && email) {
      this.userContact = { phone, email }; // Store phone and email together in one object
      this.messages.push({
        text: `Thank you! Here’s the info you provided: \nName: ${this.userName} \nPhone: ${this.userContact.phone} \nEmail: ${this.userContact.email}`,
        isUser: false,
        senderName: "Bot"
      });
      this.messages.push({
        text: `Hi ${this.userName}, We received it and will get back to you shortly. In the meantime, how may I assist you further today?`,
        isUser: false,
        senderName: "Bot"
      });

      this.isContactAsked = false; // Stop asking for phone and email
      this.isDetailsComplete = true; // Details are complete

      const userDetailsMessage = `New User Details:\nName: ${this.userName}\nPhone: ${this.userContact.phone}\nEmail: ${this.userContact.email}`;
      await this.sendToTelegram(userDetailsMessage);
      this.userMessage = ""; // Clear input field
      this.$nextTick(() => this.scrollToBottom()); // Ensure scroll happens after DOM update
      return;
    } else {
      this.messages.push({
        text: "Please enter both your phone number and email, separated by a space.",
        isUser: false,
        senderName: "Bot"
      });
      this.userMessage = ""; // Clear input field
      this.$nextTick(() => this.scrollToBottom()); // Ensure scroll happens after DOM update
      return;
    }
  }

  // If user has entered their name and details are complete
  const messageTextWithName = `${this.userName}: ${message}`;
  try {
    const url = `https://api.telegram.org/bot${this.botToken}/sendMessage`;
    const payload = {
  chat_id: this.selectedChatId || this.chatId, // Send to selected user or fallback to group chat
  text: messageTextWithName,
  reply_to_message_id: this.selectedMessageId || this.lastUserMessageId || null, // Reply to specific user's message
};
    const response = await axios.post(url, payload);
    if (response.data.ok) {
      this.messages.push({ text: message, isUser: true, senderName: this.userName });
      this.userMessage = ""; // Clear input field
      this.selectedMessageId = null; // Reset after reply
    } else {
      console.error("Error sending message:", response.data.description);
    }
  } catch (error) {
    console.error("Error sending message:", error);
  }
  this.$nextTick(() => this.scrollToBottom());
},
async sendToTelegram(message) {
    try {
      const url = `https://api.telegram.org/bot${this.botToken}/sendMessage`;
      const payload = {
        chat_id: this.selectedChatId || this.chatId, // If a specific chat_id is selected, use it; otherwise, use the default group chat_id
        text: message, // The message you want to send
      };

      const response = await axios.post(url, payload);
      if (response.data.ok) {
        console.log("Message sent successfully!");
      } else {
        console.error("Error sending message:", response.data.description);
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  },
    async fetchMessages() {
      if (this.fetchingMessages) return;
      this.fetchingMessages = true;

      try {
        const url = `https://api.telegram.org/bot${this.botToken}/getUpdates`;
        const payload = this.lastUpdateId ? { offset: this.lastUpdateId + 1 } : {};
        const response = await axios.post(url, payload);
        const updates = response.data.result;

        if (updates.length > 0) {
          updates.forEach((update) => {
            if (update.message) {
              const chatId = update.message.chat.id;
              const text = update.message.text || "[No Text]";
              const firstName = update.message.from.first_name || "Unknown";
              const lastName = update.message.from.last_name || ""; // Optional
              const sender = `${firstName} ${lastName}`.trim() || "User";

              // Log user information
              console.log(`Received message from ${sender}`);
              console.log(`Message: ${text}`);
              console.log(`Chat ID: ${chatId}`);

              // Save the last user message ID (this allows us to reply to the most recent user message)
              if (update.message.chat.id === chatId) {
                this.lastUserMessageId = update.message.message_id;
              }

              // Add received message to the list
              this.messages.push({
                text: text,
                isUser: false, // Bot message
                senderName: sender,
                chatId, // Store sender's chatId
                message_id: update.message.message_id, // Save the message ID for replies
              });
            }

            // Update last update ID
            this.lastUpdateId = update.update_id;
          });

          // Scroll to the bottom of the chat container
          this.scrollToBottom();
        }
      } catch (error) {
        console.error("Error fetching messages:", error);
      } finally {
        this.fetchingMessages = false;
      }
    },

    toggleChatVisibility() {
    this.isChatVisible = !this.isChatVisible;
    if (this.isChatVisible) {
      this.fetchMessages();
      this.fetchInterval = setInterval(this.fetchMessages, 2000); // Poll every 2 seconds
    } else {
      clearInterval(this.fetchInterval); // Stop polling when chat is closed
    }
  },

    selectMessage(msg) {
      this.selectedMessageId = msg.message_id; // Store the message ID to reply to
      this.selectedChatId = msg.chatId; // Store the chat_id of the user who sent the message
    },
    scrollToBottom() {
    this.$nextTick(() => {
      const chatContainer = document.querySelector(".messages");
      if (chatContainer) {
        chatContainer.scrollTop = chatContainer.scrollHeight;
      }
    });
  },

    },
};
</script> -->

